import { validateCompanyCode } from '@app/lib/company-code/validateCompanyCode';
import { parseLithuanianPersonalCode } from '@app/lib/personal-code/parseLithuanianPersonalCode';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { boolean, object, ref, string } from 'yup';

export const OwnerStepSchema = object({
    ownerFirstName: string().required('eshop.transport.validation.invalidFirstName'),
    ownerLastName: string().when('$isCompany', {
        is: true,
        then: schema => schema.optional(),
        otherwise: schema => schema.required('eshop.transport.validation.invalidLastName'),
    }),
    ownerPersonalCode: string()
        .required('eshop.transport.validation.invalidPersonalCode')
        .test(
            'is-valid-personal-code',
            'eshop.transport.validation.invalidPersonalCode',
            value => !!value && (parseLithuanianPersonalCode(value).isValid || validateCompanyCode(value).isValid),
        ),
    ownerCountry: string().required('address.validation.invalidCountry'),
    ownerCity: string().required('address.validation.invalidCity'),
    ownerStreet: string().required('address.validation.invalidStreet'),
    ownerPostalCode: string().required('address.validation.invalidPostalCode'),
    ownerHouseNumber: string().required('address.validation.invalidHouseNumber'),
    ownerApartmentNumber: string().nullable(),
    phoneNumber: string()
        .required('auth.validation.invalidPhoneNumber')
        .test('is-valid-phone', 'auth.validation.invalidPhoneNumber', value => {
            if (!value) {
                return true;
            }

            return isValidPhoneNumber(value);
        }),
    email: string().required('profile.validation.fieldRequired').email('profile.validation.invalidEmail'),
    emailConfirmation: string()
        .required('profile.validation.fieldRequired')
        .oneOf([ref('email')], 'eshop.transport.validation.emailsDoNotMatch'),
    insuredByOwner: boolean(),
    payerFirstName: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('eshop.transport.validation.invalidFirstName'),
    }),
    payerLastName: string().when(['insuredByOwner', '$isCompany'], {
        is: (insuredByOwner: boolean, isCompany: boolean) => !insuredByOwner && !isCompany,
        then: schema => schema.required('eshop.transport.validation.invalidLastName'),
        otherwise: schema => schema.optional(),
    }),
    payerPersonalCode: string().when('insuredByOwner', {
        is: false,
        then: schema =>
            schema
                .required('eshop.transport.validation.invalidPersonalCode')
                .test(
                    'is-valid-personal-code',
                    'eshop.transport.validation.invalidPersonalCode',
                    value =>
                        !!value && (parseLithuanianPersonalCode(value).isValid || validateCompanyCode(value).isValid),
                ),
    }),
    payerCountry: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('address.validation.invalidCountry'),
    }),
    payerCity: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('address.validation.invalidCity'),
    }),
    payerStreet: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('address.validation.invalidStreet'),
    }),
    payerPostalCode: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('address.validation.invalidPostalCode'),
    }),
    payerHouseNumber: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('address.validation.invalidHouseNumber'),
    }),
    payerApartmentNumber: string().nullable(),
    payerPhoneNumber: string().when('insuredByOwner', {
        is: false,
        then: schema =>
            schema
                .required('auth.validation.invalidPhoneNumber')
                .test('is-valid-phone', 'auth.validation.invalidPhoneNumber', value => {
                    if (!value) {
                        return true;
                    }

                    return isValidPhoneNumber(value);
                }),
    }),
    payerEmail: string().when('insuredByOwner', {
        is: false,
        then: schema => schema.required('profile.validation.fieldRequired').email('profile.validation.invalidEmail'),
    }),
    payerEmailConfirmation: string().when('insuredByOwner', {
        is: false,
        then: schema =>
            schema
                .required('profile.validation.fieldRequired')
                .oneOf([ref('payerEmail')], 'eshop.transport.validation.emailsDoNotMatch'),
    }),
});
